import { formatDate } from "./formatDate";

export function toFormData(data) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof Date) {
      formData.append(key, formatDate(value));
    } else if (value instanceof FileList) {
      Array.from(value).forEach((file) => formData.append(key, file));
    } else {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    }
  });
  return formData;
}
